module.exports = __webpack_public_path__ + "img/page-ico.95901e6e.png";